import { createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';
import thunkMiddleware from 'redux-thunk';

import rootReducer from './reducer';

const getInitialState = () => {
  // eslint-disable-next-line no-undef
  if (!ssr.isOnClient) return {};

  return window.INITIAL_STATE;
};

const persistedState = getInitialState();
const middleware = [thunkMiddleware];

if (process.env.NODE_ENV !== 'production') {
  middleware.push(logger);
}

const store = createStore(rootReducer, persistedState, applyMiddleware(...middleware));

export default store;
